import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFeatureValue } from "@growthbook/growthbook-react";

import { FEATURE_FLAGS, CATEGORY_REDESIGN_CHRISTMAS_VARIANTS } from "enums/growthbook";

const CHRISTMAS_CATEGORY_PATH = "/browse/holiday-ecards";

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export const useScrollToTopOnPathnameChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const useScrollToTopOnNewCategory = () => {
  const birthdayCategoryPage = useFeatureValue(
    FEATURE_FLAGS.CATEGORY_REDESIGN_CHRISTMAS,
    CATEGORY_REDESIGN_CHRISTMAS_VARIANTS.BASELINE,
  );
  const isBirthdayCategoryNewPage =
    birthdayCategoryPage === CATEGORY_REDESIGN_CHRISTMAS_VARIANTS.NEW_CATEGORY_DESIGN_CHRISTMAS;
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === CHRISTMAS_CATEGORY_PATH && isBirthdayCategoryNewPage) {
      const originalScrollRestoration = window.history.scrollRestoration;

      if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });

      return () => {
        if ("scrollRestoration" in window.history) window.history.scrollRestoration = originalScrollRestoration;
      };
    }
    return () => {};
  }, [pathname, isBirthdayCategoryNewPage]);
};

export default useScrollToTop;
